import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Switch as MaterialSwitch,
  Tooltip,
} from '@mui/material';
import { AlertColor as AlertSeverity } from '@mui/material/Alert';
import {
  GridRenderCellParams,
  GridRowData,
  GridSortModel,
} from '@mui/x-data-grid';
import { AxiosResponse, Method } from 'axios';
import { ValidationError } from 'class-validator';
import clsx from 'clsx';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import moment from 'moment';
import { OptionsObject, SnackbarKey } from 'notistack';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useMutation, UseMutationResult } from 'react-query';
import {
  generatePath,
  Link,
  NavLink,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';
import {
  SetterOrUpdater,
  useRecoilStateLoadable,
  useRecoilValueLoadable,
  useSetRecoilState,
} from 'recoil';
import { Logger } from '../../common/Logger';
import {
  trackAddTeamPowerList,
  trackClickedPowerListsPriorityTableHeader,
  trackEditPowerList,
} from '../../common/userTracking';
import excelSVG from '../../images/excel.svg';
import {
  IUserAtom,
  // Role,
  user,
} from '../../recoil/atoms/user';
import {
  methodNameEnum,
  refetchToggle,
} from '../../recoil/selectors/makePHPRequest';
import {
  IPermissions,
  permissionsSelector,
} from '../../recoil/selectors/permissionsSelector';
import { getApiMutation } from '../../services/rest/getApiMutation';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { toAbsoluteUrl } from '../../_metronic/_helpers';
import { DeletePowerlistModal } from '../components/modals/DeletePowerlistModal';
import {
  getMappingCRMId,
  nullIfHasMappingCrmId,
  PowerlistModal,
} from '../components/modals/PowerlistModal';
import { SpreadsheetsModal } from '../components/modals/SpreadsheetsModal';
import {
  IAlertWithProgressBar,
  useSnackbarWithStyles,
} from '../components/notifications/SnackbarProviderWithStyles';
import { priorityRange } from '../components/priorities';
import dataTableScss from '../modules/Manage/pages/queues-table/data-table.module.css';
import {
  DataTable,
  IColDef,
  IToolbarComponent,
} from '../modules/Manage/pages/queues-table/DataTable';
import {
  EnhancedTableToolbar,
  ToolbarAddDeleteButton,
} from '../modules/Manage/pages/queues-table/EnhancedTableToolbar';
import { usePowerlistDataTableStyles } from './styles/usePowerlistDataTableStyles';

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;
class Powerlist {
  id!: number;
  powerlistId!: number;
  name!: string;
  status!: 0 | 1;
  autostartOnLogon!: 0 | 1;
  mustDespositionCalls!: 0 | 1;
  ignoreDNC!: 0 | 1;
  assignToAgentOnAnswer!: 0 | 1;
  overrideOwnerOnAnswer!: 0 | 1;
  onlyDialFromOwnerIfOwned!: 0 | 1;
  secondsBeforeTimeout!: number;
  maxAttempts!: number;
  dialAtATime!: number;
  maxAttemptsPerDay!: number;
  minDurationBeforeCallRetryInMin!: number;
  maxWaitAfterCallInSec!: number;
  powerlistHours!: string;
  useBusinessHoursForPowerlist!: 0 | 1;
  targetHours!: string;
  useBusinessHoursForTarget!: 0 | 1;
  maxSmsPerTemplateCount!: number;
  maxSmsPerTemplateDurationInMin!: number;
  createdByUserId!: number;
  updatedDate!: string;
  createdDate!: string;
}

class ViewPowerlists {
  powerlists!: Powerlist[];
}
// TODO: move to centeralized location
export enum ErrorEnum {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  POWERLIST_INVALID = 'POWERLIST_INVALID',
  POWERLIST_ACTION_REQUIRED = 'POWERLIST_ACTION_REQUIRED',
  POWERLIST_IS_FORWARDED_TO = 'POWERLIST_IS_FORWARDED_TO',
  POWERLIST_NOT_FOUND = 'POWERLIST_NOT_FOUND',
  FK_POWERLIST_ACTION__SMS_TEMPLATES = 'FK_POWERLIST_ACTION__SMS_TEMPLATES',
  FK_POWERLIST__QUEUES = 'FK_POWERLIST__QUEUES',
  FK_POWERLIST__BUSINESS_DISPOSITIONS = 'FK_POWERLIST__BUSINESS_DISPOSITIONS',
}

/**
 * Custom error containing ValidationError[]
 *
 * @see https://javascript.info/custom-errors
 */
export class ErrorOnValidate<T = any> extends Error {
  errorType?: ErrorEnum;
  validationErrors?: ValidationError[];
  entities?: T[];
  isErrorOnValidate: boolean;

  constructor(
    message: string,
    errorType?: ErrorEnum,
    errorData?: {
      validationErrors?: ValidationError[];
      entities?: T[];
    }
  ) {
    super(message); // (1)
    this.name = 'ErrorOnValidate'; // (2)
    this.isErrorOnValidate = true;
    this.errorType = errorType;
    this.validationErrors = errorData?.validationErrors;
    this.entities = errorData?.entities;
  }
}

const PowerlistToggle = (props: {
  params: GridRenderCellParams;
  mutation: UseMutationResult<
    AxiosResponse<any>,
    unknown,
    {
      endpoint: string;
      payload?:
        | {
            [key: string]: any;
          }
        | undefined;
      method?: Method | undefined;
      omitBusinessIdAndApikey?: boolean | undefined;
    },
    unknown
  >;
  enqueueSnackbarWithStyles: (
    alertComponentProps: IAlertWithProgressBar,
    snackbarProps?: OptionsObject | undefined
  ) => SnackbarKey | null;
  setRefetchToggleForPowerlists: SetterOrUpdater<any>;
  userAtom: IUserAtom;
  disabled?: boolean;
}) => {
  const [checked, setChecked] = useState<boolean>(
    Boolean(props.params.value === 'active')
  );
  useEffect(() => {
    setChecked(Boolean(props?.params?.value === 'active'));
  }, [props?.params?.value]);
  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): Promise<void> => {
    setChecked(checked);
    try {
      await props.mutation.mutateAsync({
        endpoint: `${endpointEnum.TOGGLE_POWERLIST_STATUS}`,
        payload: {
          businessId: props.userAtom?.business?.businessid as any,
          powerlistId: props.params.row.id,
          userid: props.userAtom?.userid,
          apiKey: props.userAtom?.apikey,
          call: 'togglePowerlistStatus',
        } as Partial<Powerlist>,
        method: 'post',
      });

      // refetch business queues
      props.setRefetchToggleForPowerlists({});
    } catch (exception) {
      setChecked(!checked);
      const message: string | React.ReactNode =
        'Failed to change status of powerlist';
      const severity: AlertSeverity = 'error';
      props.enqueueSnackbarWithStyles({
        message,
        alertProps: {
          severity,
        },
      });
    }
  };

  return (
    <MaterialSwitch
      checked={checked}
      onChange={handleChange}
      color="primary"
      name="status"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      disabled={props.disabled}
    />
  );
};

export function ManagePowerlists() {
  const _classes = usePowerlistDataTableStyles();
  const history = useHistory();
  const [deleteItemId, setDeleteItemId] = useState<
    string | number | undefined
  >();
  const [userAtomLoadable, setUserAtom] = useRecoilStateLoadable<
    IUserAtom | Record<string, unknown>
  >(user);
  const userAtom = userAtomLoadable.contents as IUserAtom;
  const data = {
    call: methodNameEnum.GET_BUSINESS_DATA,
  };

  const businessDataLoadable = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify(data),
    })
  );
  const setRefetchToggleForbusinessData = useSetRecoilState(
    refetchToggle(endpointEnum.GET_BUSINESS_DATA)
  );
  useEffect(() => {
    setRefetchToggleForbusinessData?.({});
  }, []);
  const powerlistReportLoadable = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: `${endpointEnum.GET_BUSINESS_POWERLISTS}`,
      method: 'POST',
      payloadJsonString: JSON.stringify({
        call: 'v1/getBusinessPowerlists',
      }),
    })
  );
  const disablePowerlistToggle = !businessDataLoadable.contents?.response?.data
    ?.result?.[0]?.allowAgentPowerlist;

  const mutation = useMutation(getApiMutation(userAtom, setUserAtom));

  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();

  const powerlistReportCache = useRef<ViewPowerlists & GridRowData[]>(
    [] as any
  );

  powerlistReportCache.current = useMemo(
    () =>
      (powerlistReportLoadable?.contents?.response as AxiosResponse)?.data ??
      powerlistReportCache?.current,
    [powerlistReportLoadable]
  );
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const {
    canManage,
    // role
  } = permissionsLoadable.contents as IPermissions;
  // const isSuperAdminBoolean = role === Role.SUPERADMIN;
  const ToolbarComponent = useCallback(
    (props: IToolbarComponent) => (
      <EnhancedTableToolbar
        {...props}
        dataType="Powerlists"
        // numSelected={selected.length}
        rightComponent={
          <ToolbarAddDeleteButton
            dataPup="add-new-business-powerlist"
            addButtonText="New Team PowerList"
            // numSelected={selected.length}
            onClickForAdd={() => {
              trackAddTeamPowerList();
              history.push('/manage/powerlists/add');
            }}
            isLoading={props.isLoading}
          />
        }
      />
    ),
    []
  );
  const setRefetchToggleForPowerlists = useSetRecoilState(
    refetchToggle(`${endpointEnum.GET_BUSINESS_POWERLISTS}`)
  );
  const handlePreflightCheck = async (id: string | number) => {
    let message: string | React.ReactNode = 'Update sucessful'; // ! to ignore usage before assignment error
    let severity: AlertSeverity = 'success';
    try {
      const response = await mutation.mutateAsync({
        // placeholder for actual call
        endpoint: `${endpointEnum.DELETE_POWERLIST}`,
        method: 'options',
      });
      if (response.status === 200) {
        history.push(generatePath('/manage/powerlists/:id/delete', { id }));
      }
    } catch (exception) {
      message = 'Failed to delete powerlist (please try again later)';
      severity = 'error';
      enqueueSnackbarWithStyles({
        message,
        alertProps: {
          severity,
        },
      });
    }
  };
  const handleDeletion = async (id: string | number) => {
    let message: string | React.ReactNode = 'Update sucessful'; // ! to ignore usage before assignment error
    let severity: AlertSeverity = 'success';

    try {
      const response = await mutation.mutateAsync({
        // placeholder for actual call
        endpoint: `${endpointEnum.DELETE_POWERLIST}`,
        method: 'POST',
        omitBusinessIdAndApikey: true,
        payload: {
          businessId: userAtom?.business?.businessid as any,
          powerlistId: Number(id),
          userid: userAtom?.userid,
          apiKey: userAtom?.apikey,
          call: 'deletePowerlist',
        },
      });

      // log success
      Logger.trace({ message, response }, 'deletePowerlist');

      // refetch business queues
      setRefetchToggleForPowerlists({});
    } catch (exception) {
      message = 'Failed to delete powerlist (please try again later)';
      severity = 'error';

      // log error
      Logger.trace({ message, exception }, 'deletePowerlist');
    }

    // clear selections list
    setDeleteItemId(undefined);

    enqueueSnackbarWithStyles({
      message,
      alertProps: {
        severity,
      },
    });
  };

  const setSelectedPowerlistId = (powerlistId) => {
    setUserAtom({
      ...userAtom,
      selectedPowerlistId: powerlistId,
    });
  };

  const getEditPowerlistLink = ({
    params,
    powerlistId,
  }: {
    params: GridRenderCellParams;
    powerlistId?: string;
  }): string => {
    let editLink = `/manage/powerlists/${powerlistId ?? ':id'}/edit`;
    const mappingCrmId = getMappingCRMId(params.row);
    if (mappingCrmId) {
      editLink += `?mappingCrmId=${mappingCrmId}`;
    }
    return editLink;
  };

  const handlePowerListClone = async (powerlistId: number) => {
    let message: string | React.ReactNode = 'PowerList Cloned';
    let severity: AlertSeverity = 'success';
    try {
      const payload = {
        powerlistId: powerlistId,
        businessid: userAtom?.businessid,
        businessId: userAtom?.businessid,
        userId: userAtom?.userid,
        userid: userAtom?.userid,
      };

      const response = await mutation.mutateAsync({
        domain: process.env.VITE_APP_CDK_DOMAIN,
        stage: 'auto',
        endpoint: endpointEnum.CLONE_POWERLIST,
        method: 'post',
        payload,
      });

      message += `: ${response.data.data.name} created`;
      // log success
      Logger.trace({ message, response }, 'clonePowerlist');
    } catch (exception) {
      message = 'Failed to clone powerlist (please try again later)';
      severity = 'error';

      // log error
      Logger.trace({ message, exception }, 'clonePowerlist');
    }
    enqueueSnackbarWithStyles({
      message,
      alertProps: {
        severity,
      },
    });
    setRefetchToggleForPowerlists({});
  };

  const actionColumnFormatter = useCallback(
    (params: GridRenderCellParams) => {
      const hasMappingCrmId = !!getMappingCRMId(params.row);
      const editLink = getEditPowerlistLink({ params });

      // return ActionColumn({
      //   deleteItemId,
      //   setDeleteItemId,
      //   isLoading: mutation.isLoading,
      //   handleDeletion: handlePreflightCheck,
      //   editLink: editLink,
      //   // spreadSheetsLink: '/manage/powerlists/:id/spreadsheets',
      //   setSelectedPowerlistId,
      //   disableViewContacts: hasMappingCrmId,
      //   disableUploadStatus: hasMappingCrmId,
      //   disableDelete: hasMappingCrmId,
      // })(params as GridValueFormatterParams<any>);

      return (
        <PopupState variant="popover">
          {(popupState) => (
            <>
              <Tooltip title="View actions">
                <IconButton {...bindTrigger(popupState)} size="large">
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Tooltip>
              <Menu {...bindMenu(popupState)} disableScrollLock={true}>
                <MenuItem
                  aria-label="view contacts"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedPowerlistId(params.row.powerlistId);
                    popupState.close();
                  }}
                  disabled={hasMappingCrmId}
                >
                  <NavLink
                    to={generatePath(
                      `/manage/powerlists/${params.row.powerlistId}/view-contacts`
                    )}
                    className={_classes.dropdownButton}
                    data-powerlistid={params.row.powerlistid}
                  >
                    <GroupIcon className={_classes.flushIconButton} />
                    <small className={_classes.navLinkText}>
                      View Contacts
                    </small>
                  </NavLink>
                </MenuItem>

                <MenuItem
                  aria-label="upload status"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedPowerlistId(params.row.powerlistId);
                    popupState.close();
                  }}
                  disabled={hasMappingCrmId}
                >
                  <NavLink
                    to={generatePath(
                      '/manage/powerlists/:id/spreadsheets',
                      params.row
                    )}
                    className={_classes.dropdownButton}
                    data-powerlistid={params.row.powerlistid}
                  >
                    <img style={{ height: 20 }} src={excelSVG}></img>
                    <small className={_classes.navLinkText}>
                      Upload Status
                    </small>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  aria-label="clone powerlist"
                  onClick={async (e) => {
                    e.preventDefault();
                    await handlePowerListClone(params.row.powerlistId);
                    popupState.close();
                  }}
                >
                  <div
                    className={_classes.dropdownButton}
                    data-powerlistid={params.row.powerlistid}
                  >
                    <ContentCopyIcon />
                    <small className={_classes.navLinkText}>
                      Clone PowerList
                    </small>
                  </div>
                </MenuItem>
                <MenuItem
                  aria-label="edit powerlist"
                  onClick={(e) => {
                    e.preventDefault();
                    popupState.close();
                  }}
                >
                  <NavLink
                    to={generatePath(editLink, params.row)}
                    className={_classes.dropdownButton}
                    data-powerlistid={params.row.powerlistid}
                  >
                    <CreateIcon className={_classes.editIconButton} />
                    <small className={_classes.navLinkText}>
                      Edit PowerList
                    </small>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  aria-label="delete"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePreflightCheck(params.row.id);
                    popupState.close();
                  }}
                  disabled={hasMappingCrmId}
                >
                  <div
                    className={_classes.dropdownButton}
                    data-powerlistid={params.row.powerlistid}
                  >
                    <DeleteIcon
                      className={clsx({
                        // enable styling only when not disabled
                        [_classes.deleteIconButton]: !hasMappingCrmId,
                      })}
                    />
                    <small className={_classes.navLinkText}>
                      Delete PowerList
                    </small>
                  </div>
                </MenuItem>
              </Menu>
            </>
          )}
        </PopupState>
      );
    },
    [
      deleteItemId,
      setDeleteItemId,
      mutation.isLoading,
      handlePreflightCheck,
      setSelectedPowerlistId,
      handlePowerListClone,
      _classes,
    ]
  );

  const columns = [
    {
      field: 'powerlistId',
      headerName: 'ID',
      width: 90,
    },
    {
      field: 'status',
      headerName: 'Active',
      width: 130,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <ConditionalWrapper
              condition={
                disablePowerlistToggle && params.row.isAgentPowerlist === 1
              }
              wrapper={(children: React.ReactElement) => (
                <Tooltip title="Agent powerlists are disabled">
                  {children}
                </Tooltip>
              )}
            >
              <div>
                <PowerlistToggle
                  params={params}
                  mutation={mutation}
                  enqueueSnackbarWithStyles={enqueueSnackbarWithStyles}
                  setRefetchToggleForPowerlists={setRefetchToggleForPowerlists}
                  userAtom={userAtom}
                  disabled={Boolean(
                    disablePowerlistToggle && params.row.isAgentPowerlist === 1
                  )}
                />
              </div>
            </ConditionalWrapper>
          </>
        );
      },
      disableExport: true,
    },
    {
      field: 'name',
      headerName: 'PowerList',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: (params: GridRenderCellParams) => {
        const editLink = getEditPowerlistLink({
          params,
          powerlistId: params.row.powerlistId,
        });
        return (
          <Tooltip title="Click To Edit">
            <Link
              to={editLink}
              onClick={() => {
                trackEditPowerList();
              }}
            >
              {params.value}
            </Link>
          </Tooltip>
        );
      },
    },
    {
      field: 'powerlistPriority',
      headerName: 'Priority',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      Header: () => {
        return (
          <div
            className={dataTableScss.fullWidth}
            onClick={() => {
              trackClickedPowerListsPriorityTableHeader();
            }}
          >
            Priority
          </div>
        );
      },
      renderCell: (params) => {
        const { powerlistPriority } = params.row;

        // since priority 0 is Lowest we need to return null likk this
        if (!powerlistPriority && powerlistPriority !== 0) return '-';

        const priority = priorityRange.find(
          (p) => +p.value === +params.row.powerlistPriority
        );
        return priority?.name ? priority.name : '';
      },
    },
    {
      field: 'countUploaded',
      headerName: '# Uploaded',
      width: 140,
      renderCell: (params) =>
        nullIfHasMappingCrmId(params, () => params.row.countUploaded),
    },
    {
      field: 'countQueued',
      headerName: '# Queued',
      width: 140,
      renderCell: (params) => params.row.countQueued ?? '-',
    },
    {
      field: 'countDeferred',
      headerName: '# Deferred',
      width: 140,
      renderCell: (params) =>
        nullIfHasMappingCrmId(params, () => params.row.countDeferred),
    },
    {
      field: 'countRemoved',
      headerName: '# Removed',
      width: 140,
      renderCell: (params) =>
        nullIfHasMappingCrmId(params, () => params.row.countRemoved),
    },
    {
      field: 'subscribedCount',
      headerName: '# Subscribed Agents',
      width: 140,
      renderCell: (params) =>
        nullIfHasMappingCrmId(params, () => params.row.subscribedCount),
    },
    {
      field: 'sessionCount',
      headerName: '# Agents In Session',
      width: 140,
      renderCell: (params) =>
        nullIfHasMappingCrmId(params, () => params.row.sessionCount),
    },
    {
      field: 'createdDate',
      headerName: 'Create Date',
      // headerClassName: dataTableScss.fullWidth,
      // cellClassName: dataTableScss.fullWidth,
      width: 140,
      renderCell: (params) =>
        !!params.value?.length
          ? moment(params.value || undefined)?.format('MM/DD/YYYY')
          : '',
    },
    {
      field: '_actions',
      headerName: '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + 'Actions',
      width: 180,
      headerAlign: 'center',
      cellClassName: (_classes.dropdownOverflow, dataTableScss.center),
      enableSorting: false,
      disableExport: true,
      disableSearch: true, // do not search field content
      headerClassName: dataTableScss.fullWidth,
      // cellClassName: dataTableScss.fullWidth,
      hide: canManage === false, // must be explicit compare else warning: React has detected a change in the order of Hooks called by null
      renderCell: (params: GridRenderCellParams) => {
        return actionColumnFormatter(params);
      },
    },
  ] as IColDef[];
  const [sortModel, setGridSortModel] = React.useState<GridSortModel>([
    { field: 'name', sort: 'asc' },
  ]);
  const getLogo = () => {
    return toAbsoluteUrl('/media/logos/cadenceView.svg');
  };
  return (
    <Paper square={true} elevation={0}>
      <Switch>
        <Route path="/manage/powerlists/:id/edit">
          {({ history, match }) => (
            <PowerlistModal
              show={match != null}
              id={match?.params.id}
              handleClose={() => {
                history.push('/manage/powerlists');
                setRefetchToggleForPowerlists({});
              }}
              enqueueSnackbarWithStyles={enqueueSnackbarWithStyles}
              powerlistReportCache={powerlistReportCache}
            />
          )}
        </Route>
        <Route path="/manage/powerlists/:id/delete">
          {({ history, match }) => (
            <DeletePowerlistModal
              handleDeletion={handleDeletion}
              show={match != null}
              deleteId={match?.params.id}
              handleClose={() => {
                history.push('/manage/powerlists');
                setRefetchToggleForPowerlists({});
              }}
            />
          )}
        </Route>
        <Route path="/manage/powerlists/add">
          {({ history, match }) => (
            <PowerlistModal
              id={null}
              show={match != null}
              handleClose={() => {
                history.push('/manage/powerlists');
                setRefetchToggleForPowerlists({});
              }}
              enqueueSnackbarWithStyles={enqueueSnackbarWithStyles as any}
              powerlistReportCache={powerlistReportCache}
            />
          )}
        </Route>
        <Route path="/manage/powerlists/:id/spreadsheets">
          {({ history, match }) => (
            <SpreadsheetsModal
              showSpreadsheets={match != null}
              id={match?.params.id}
              handleHideSpreadsheets={() => {
                history.push('/manage/powerlists');
                setRefetchToggleForPowerlists({});
              }}
            />
          )}
        </Route>
      </Switch>
      {powerlistReportCache?.current?.powerlists?.length ||
      powerlistReportLoadable?.state === 'loading' ? (
        <DataTable
          // passing JSON object as rows to DataTable causes react error
          // className={classes.dataTable}
          ToolbarComponent={ToolbarComponent}
          rows={powerlistReportCache.current?.powerlists ?? []}
          loading={powerlistReportLoadable?.state !== 'hasValue'}
          columns={columns}
          sortModel={sortModel}
          setGridSortModel={setGridSortModel}
        />
      ) : (
        <Paper
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
          square={true}
          elevation={0}
        >
          <div
            style={{
              flexDirection: 'column',
              textAlign: 'center',
            }}
          >
            <h1 style={{ paddingTop: '35px' }}>
              <b>Well Hey There...</b>
            </h1>
            <h2>Let's add your first PowerList</h2>
            <img style={{ height: '500px' }} alt="logo" src={getLogo()} />
            <br />
            <Button
              className={_classes.button}
              name="ADD NEW POWERLIST"
              variant="contained"
              startIcon={<AddIcon />}
              color="primary"
              onClick={() => {
                history.push('/manage/powerlists/add');
              }}
              disableElevation
              // disabled={disabled}
            >
              ADD NEW TEAM POWERLIST
            </Button>
            <br />
            <Button
              className={_classes.toolbarButton}
              variant="outlined"
              color="primary"
              endIcon={<HelpOutlineIcon />}
              target="_blank"
              href="https://support.kixie.com/hc/en-us/articles/4565589331483-How-to-Set-Up-PowerLists-"
              rel="noopener noreferrer"
            >
              LEARN MORE ABOUT POWERLIST
            </Button>
          </div>
        </Paper>
      )}
    </Paper>
  );
}
